<template>
  <div class="flex h-full flex-col justify-center">
    <div class="mx-auto my-auto flex max-w-max flex-col items-center justify-center">
      <p class="text-body-large mb-5 font-medium">{{ t("ticket_already_created") }}</p>
      <Button class="max-auto max-w-max text-center" :variant="ButtonVariant.Primary" @click="goToTicket">
        {{ t("go_to_entity", { entity: t("ticket", 1).toLowerCase() }) }}
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
  const { t } = useI18n();
  const { ticketId } = defineProps<{
    ticketId: number;
  }>();

  const goToTicket = () => {
    createTicketClose();
    const link = useRouter().resolve({ name: "tickets-id", params: { id: ticketId } })?.href;
    useRouter().push(link);
  };
</script>
